import { throttle } from "lodash";

// socket/visibility.js
let socketRef = null;

 

const onVisibilityChange = throttle(() => {
  console.count("visibilitychange fired");

  if (document.visibilityState === "visible") {
    if (socketRef && !socketRef.connected) {
      console.log("Reconnect socket safely");
      socketRef.connect();
    }
  }
}, 1500); // فقط یکبار در هر ۱ ثانیه اجرا می‌شود

export const registerVisibilityChange = (socket) => {
  socketRef = socket;

  // 🔥 کلید حل مشکل
  document.removeEventListener("visibilitychange", onVisibilityChange);
  document.addEventListener("visibilitychange", onVisibilityChange);
};
